import React from 'react'
import PropTypes from 'prop-types'
import ModalComponent from '../mini/ModalComponent'
import { confirmable } from 'react-confirm'
import {
  headingMessages,
  bodyMessages,
  buttonMessages
} from '../../utils/messages/modal'

class Confirmation extends React.Component {
  constructor(props) {
    super(props)
    this.handleProceed = this.handleProceed.bind(this)
    this.handleDismiss = this.handleDismiss.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
  }

  componentDidMount() {
    this.refs.modal.refs.modal.show()
  }

  // Adding to built-in prop to get modal animation
  handleProceed() {
    this.props.proceed()
    this.refs.modal.refs.modal.hide()
  }

  // Adding to built-in prop to get modal animation
  handleDismiss() {
    this.props.dismiss()
    this.refs.modal.refs.modal.hide()
  }

  // Adding to built-in prop to get modal animation
  handleCancel() {
    this.props.cancel()
    this.refs.modal.refs.modal.hide()
  }

  render() {
    const { show, intl } = this.props

    const intlHeading = intl.formatMessage(headingMessages.wait)
    const intlBody = intl.formatMessage(bodyMessages.youreLeaving)
    const intlPrimaryButton = intl.formatMessage(buttonMessages.leaveAnyway)
    const intlSecondaryButton = intl.formatMessage(buttonMessages.cancel)

    return (
      <div className="modal">
        <ModalComponent
          ref="modal"
          show={show}
          onHide={this.handleDismiss}
          klass="modal lose-progress-modal"
          modalId="leaveProgressModal"
          logoKlass="logo alert"
          headingKlass="modal-heading alert no-cap"
          headingText={intlHeading}
          bodyText={intlBody}
          primaryButtonText={intlPrimaryButton}
          secondaryButtonText={intlSecondaryButton}
          primaryButtonAction={this.handleProceed}
          secondaryButtonAction={this.handleCancel}
        />
      </div>
    )
  }
}

Confirmation.propTypes = {
  confirmation: PropTypes.string,
  show: PropTypes.bool,
  proceed: PropTypes.func, // called when ok button is clicked.
  cancel: PropTypes.func, // called when cancel button is clicked.
  dismiss: PropTypes.func, // called when backdrop is clicked or escaped.
  intl: PropTypes.object
}

export default confirmable(Confirmation)



// WEBPACK FOOTER //
// ./src/components/HOC/Confirmation.js